import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { registerTenantApi } from '../services/api';

export default function RegisterTenant() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    empresa_nombre: '', slug: '', nombre: '', email: '', password: '', confirmPassword: '',
    codigo_referido: (new URLSearchParams(window.location.search).get('ref') || '').toUpperCase(),
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => {
      const upd = { ...f, [name]: value };
      if (name === 'empresa_nombre') {
        upd.slug = value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      }
      return upd;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await registerTenantApi({
        empresa_nombre: form.empresa_nombre,
        slug: form.slug,
        nombre: form.nombre,
        email: form.email,
        password: form.password,
        codigo_referido: form.codigo_referido || undefined,
      });
      localStorage.setItem('erp_token', res.data.token);
      localStorage.setItem('erp_user', JSON.stringify(res.data.user));
      window.location.href = '/dashboard';
    } catch (err) {
      setError(err.response?.data?.error || 'Error al registrar empresa');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.container}>
      <div style={S.card}>
        <div style={S.header}>
          <div style={S.logo}>ERP</div>
          <h1 style={S.title}>Crear nueva empresa</h1>
          <p style={S.subtitle}>Registra tu empresa para comenzar</p>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div style={S.error}>{error}</div>}

          <p style={S.sectionLabel}>Datos de la empresa</p>
          <div style={S.field}>
            <label style={S.label}>Nombre de la empresa</label>
            <input style={S.input} name="empresa_nombre" value={form.empresa_nombre}
              onChange={handleChange} placeholder="Mi Empresa S.A.S." required />
          </div>
          <div style={S.field}>
            <label style={S.label}>Identificador único (slug)</label>
            <input style={S.input} name="slug" value={form.slug}
              onChange={handleChange} placeholder="mi-empresa" required />
            <span style={S.hint}>Solo letras minúsculas, números y guiones</span>
          </div>
          <div style={S.field}>
            <label style={S.label}>Código de referido (opcional)</label>
            <input style={S.input} name="codigo_referido" value={form.codigo_referido}
              onChange={handleChange} placeholder="CONT-XXXXXX" />
            <span style={S.hint}>Si un contador te invitó, ingresa su código.</span>
          </div>

          <p style={S.sectionLabel}>Administrador</p>
          <div style={S.field}>
            <label style={S.label}>Tu nombre</label>
            <input style={S.input} name="nombre" value={form.nombre}
              onChange={handleChange} placeholder="Juan Pérez" required />
          </div>
          <div style={S.field}>
            <label style={S.label}>Correo electrónico</label>
            <input style={S.input} type="email" name="email" value={form.email}
              onChange={handleChange} placeholder="admin@empresa.com" required />
          </div>
          <div style={S.row}>
            <div style={S.field}>
              <label style={S.label}>Contraseña</label>
              <input style={S.input} type="password" name="password" value={form.password}
                onChange={handleChange} placeholder="••••••••" required minLength={6} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Confirmar contraseña</label>
              <input style={S.input} type="password" name="confirmPassword" value={form.confirmPassword}
                onChange={handleChange} placeholder="••••••••" required />
            </div>
          </div>

          <button style={{ ...S.btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
            {loading ? 'Creando empresa...' : 'Crear empresa y comenzar'}
          </button>
        </form>
        <p style={S.footer}>
          ¿Ya tienes cuenta? <Link to="/login" style={S.link}>Inicia sesión</Link>
        </p>
      </div>
    </div>
  );
}

const S = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a', padding: '24px 16px' },
  card: { background: '#1e293b', borderRadius: 16, padding: '40px 36px', width: '100%', maxWidth: 520, boxShadow: '0 25px 50px rgba(0,0,0,0.5)' },
  header: { textAlign: 'center', marginBottom: 28 },
  logo: { display: 'inline-block', background: '#3b82f6', color: '#fff', borderRadius: 12, padding: '10px 18px', fontSize: 20, fontWeight: 700, letterSpacing: 2, marginBottom: 12 },
  title: { color: '#f1f5f9', fontSize: 22, fontWeight: 700, margin: '0 0 6px' },
  subtitle: { color: '#94a3b8', fontSize: 14, margin: 0 },
  sectionLabel: { color: '#3b82f6', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, margin: '20px 0 12px', borderBottom: '1px solid #334155', paddingBottom: 6 },
  field: { marginBottom: 14, flex: 1 },
  row: { display: 'flex', gap: 12 },
  label: { display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 5 },
  input: { width: '100%', padding: '10px 14px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#f1f5f9', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  hint: { color: '#64748b', fontSize: 11, marginTop: 3, display: 'block' },
  btn: { width: '100%', padding: '12px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 16 },
  error: { background: '#450a0a', border: '1px solid #b91c1c', borderRadius: 8, color: '#fca5a5', padding: '10px 14px', marginBottom: 16, fontSize: 13 },
  footer: { textAlign: 'center', color: '#64748b', fontSize: 13, marginTop: 20 },
  link: { color: '#3b82f6', textDecoration: 'none' },
};
